import React from "react";

const RadioButtonsComponent = ({ handleChange, handleBlur, name, defaultValue, disabled, items }) => {
    return (
      <div className="wapperRadioButton">
        {items.map(({id, value, span, divStyle},index) => (
          <div key={`key_${id}_${index}`} style={divStyle ? divStyle : null }>
            <label htmlFor={id+"_"+name}>
              <input
                className="with-gap"
                type="radio"
                name={name}
                id={`${id}_${name}`}
                value={value}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={disabled ? disabled : null}
                checked={defaultValue ? defaultValue == value : null}
              />
              <span>{span}</span>
            </label>
          </div>
        ))}
      </div>
    );
  };
  
  export default RadioButtonsComponent;